import React from 'react';
import { AspectRatio, Box, SpaceProps, BorderProps } from '@chakra-ui/react';

interface VideoPlayerProps {
  title: string;
  src: string;
  marginTop?: SpaceProps['marginTop'];
  borderRadius?: BorderProps['borderRadius'];
}

const VideoPlayer = ({
  title,
  src,
  marginTop = '',
  borderRadius = '',
}: VideoPlayerProps) => (
  <AspectRatio w="100%" marginTop={marginTop}>
    <Box
      as="iframe"
      src={src}
      title={title}
      allow="autoplay; fullscreen"
      scrolling="no"
      width="100%"
      height="auto"
      display="block"
      allowFullScreen
      borderRadius={borderRadius}
    />
  </AspectRatio>
);

VideoPlayer.defaultProps = { marginTop: undefined, borderRadius: undefined };

export default VideoPlayer;
